import { BLISS_GATEWAY_ROOT_URL } from '@utils/urlHelpers.util';

export const findACoupleGQLQuery = (coupleNames: string) => {
  const findACoupleQueryString =
    `{"query":"query FINDACOUPLE {` +
    `getEventsBySearch(criteria: { coupleNames: \\"${coupleNames}\\", eventTypes: [babyRegistry, wedding, general]}) {` +
    `totalCount ` +
    `resultCount ` +
    `results {` +
    `event { ` +
    `firebaseId ` +
    `website ` +
    `photo { url } ` +
    `domain { ` +
    `id ` +
    `domainName ` +
    `}` +
    `activeSession { ` +
    `hasUnlocked ` +
    `canAccessPage(type: registry)` +
    `} ` +
    `pageInfo(type: registry){` +
    `disabled` +
    `}` +
    `info { ownerFullName fianceeFullName ` +
    `tentativeDate { timestamp }` +
    `dateV0918 { timestamp }` +
    `finalizedDate { timestamp }` +
    `}` +
    `}` +
    `}` +
    `}` +
    `}","operationName":"FINDACOUPLE"}`;

  const url = BLISS_GATEWAY_ROOT_URL + '/graphql';
  let options = {
    method: 'POST',
    headers: {
      'Accept-Encoding': 'gzip, deflate, br',
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Connection: 'keep-alive',
      DNT: '1',
      Origin: BLISS_GATEWAY_ROOT_URL,
    },
    body: findACoupleQueryString,
  };

  return fetch(url, options).then(res => res.json());
};
